
import UserService from '../services/user'
import StorageService from '../services/storage'

export default function auth ({ next, router }) {
  // aggiungere check per validità jwt con adesso
  if (!StorageService.getItem('jwt')) {
    StorageService.clear()
    return router.push({ name: 'login' })
  }
  return UserService.me()
    .then(function () {
      return next()
    })
    .catch(() => {
      StorageService.clear()
      return router.push({ name: 'login' })
    })
}
